import Direction from "../../../types/enums/direction";
import Screen from "../../../utils/screen";
import { useState, useRef } from "react";

function useTransform(
  index: number,
  offset: number,
  direction: Direction,
  useRatio: boolean = true
): [
  React.CSSProperties,
  (increment: number, newOffset?: number) => void,
  () => void,
  (newIndex: number, newOffset?: number) => void,
  (newOffset: number) => void
] {
  const [transform, setTransform] = useState(
    -index * offset * (useRatio ? Screen.widthRatio : 1)
  );
  const styleRef = useRef<React.CSSProperties>();

  styleRef.current = {
    transform:
      direction === Direction.VERTICAL
        ? `translateY(${transform}px)`
        : `translateX(${transform}px)`,
  };

  const change = (increment: number, newOffset?: number) => {
    setTransform((previous: number) => {
      const newValue =
        previous -
        increment *
          ((newOffset || offset) * (useRatio ? Screen.widthRatio : 1));

      return newValue;
    });
  };

  const reset = () => {
    setTransform(0);
  };

  const changeBasedOnIndex = (newIndex: number, newOffset?: number) => {
    setTransform(
      -newIndex * (newOffset || offset) * (useRatio ? Screen.widthRatio : 1)
    );
  };

  const changeBasedOnOffset = (newOffset: number) => {
    setTransform(-newOffset * (useRatio ? Screen.widthRatio : 1));
  };

  return [
    styleRef.current,
    change,
    reset,
    changeBasedOnIndex,
    changeBasedOnOffset,
  ];
}

export default useTransform;
